import { combineReducers } from 'redux'
import DimensionsReducer from './reducers/dimensions-reducer'

export const rootReducer = combineReducers({
	dimensions: DimensionsReducer
})



